import { IPagination } from 'app/types/common';

export interface IPurchasesState {
  readonly purchasesById?: any;
  readonly purchaseIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPurchaseLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPurchase?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPurchaseIds?: string[];
  readonly currentPurchaseId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPurchasesSelector extends IPurchasesState {
  readonly currentPurchase?: any;
  readonly currentFormPurchase?: any;
  readonly getPurchasesFilteredByTagInSelectFormat?: any;
  readonly purchasesByIdInSelectFormat?: any;
}

export enum PurchasesActionTypes {
  GET_ALL_PURCHASES_REQUESTED = 'redux-app/purchases/GET_ALL_PURCHASES_REQUESTED',
  GET_ALL_PURCHASES_PENDING = 'redux-app/purchases/GET_ALL_PURCHASES_PENDING',
  GET_ALL_PURCHASES_SUCCESS = 'redux-app/purchases/GET_ALL_PURCHASES_SUCCESS',
  GET_ALL_PURCHASES_FAIL = 'redux-app/purchases/GET_ALL_PURCHASES_FAIL',
  GET_PURCHASE_REQUESTED = 'redux-app/purchases/GET_PURCHASE_REQUESTED',
  GET_PURCHASE_PENDING = 'redux-app/purchases/GET_PURCHASE_PENDING',
  GET_PURCHASE_SUCCESS = 'redux-app/purchases/GET_PURCHASE_SUCCESS',
  GET_PURCHASE_FAIL = 'redux-app/purchases/GET_PURCHASE_FAIL',
  UPDATE_PURCHASE_REQUESTED = 'redux-app/purchases/UPDATE_PURCHASE_REQUESTED',
  UPDATE_PURCHASE_PENDING = 'redux-app/purchases/UPDATE_PURCHASE_PENDING',
  UPDATE_PURCHASE_SUCCESS = 'redux-app/purchases/UPDATE_PURCHASE_SUCCESS',
  UPDATE_PURCHASE_FAIL = 'redux-app/purchases/UPDATE_PURCHASE_FAIL',
  CREATE_PURCHASE_REQUESTED = 'redux-app/purchases/CREATE_PURCHASE_REQUESTED',
  CREATE_PURCHASE_PENDING = 'redux-app/purchases/CREATE_PURCHASE_PENDING',
  CREATE_PURCHASE_SUCCESS = 'redux-app/purchases/CREATE_PURCHASE_SUCCESS',
  CREATE_PURCHASE_FAIL = 'redux-app/purchases/CREATE_PURCHASE_FAIL',
  CREATE_CREDIT_CARD_AND_PURCHASE_REQUESTED = 'redux-app/purchases/CREATE_CREDIT_CARD_AND_PURCHASE_REQUESTED',
  CREATE_CREDIT_CARD_AND_PURCHASE_PENDING = 'redux-app/purchases/CREATE_CREDIT_CARD_AND_PURCHASE_PENDING',
  CREATE_CREDIT_CARD_AND_PURCHASE_SUCCESS = 'redux-app/purchases/CREATE_CREDIT_CARD_AND_PURCHASE_SUCCESS',
  CREATE_CREDIT_CARD_AND_PURCHASE_FAIL = 'redux-app/purchases/CREATE_CREDIT_CARD_AND_PURCHASE_FAIL',
  DELETE_PURCHASE_REQUESTED = 'redux-app/purchases/DELETE_PURCHASE_REQUESTED',
  DELETE_PURCHASE_PENDING = 'redux-app/purchases/DELETE_PURCHASE_PENDING',
  DELETE_PURCHASE_SUCCESS = 'redux-app/purchases/DELETE_PURCHASE_SUCCESS',
  DELETE_PURCHASE_FAIL = 'redux-app/purchases/DELETE_PURCHASE_FAIL',
  SELECT_PURCHASE_REQUESTED = 'redux-app/purchases/SELECT_PURCHASE_REQUESTED',
}

export default null;
